import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";

import { useAsyncTask } from "app/utils";
import { API } from "app/services";
import { DataRow } from "app/components";
import { useSnackbar } from "notistack";

const useStyles = makeStyles(() => ({
  root: {
    justifyContent: "center",
  },
  card: {
    maxWidth: 700,
    margin: "auto",
  },
}));

let mounted = false;

const IdentityVerification= () => {
 const classes = useStyles();
  const access = useSelector((state) => state.profile.access);

  const { enqueueSnackbar } = useSnackbar();
  const [runLoadAccounts] = useAsyncTask('loadAccounts');
  const [runUpdateAccount] = useAsyncTask('updateAccount');
  const [accounts, setAccounts] = useState([]);
  const [checked, setChecked] = useState([]);

  useEffect(() => {
    mounted = true;
    return () => (mounted = false);
  }, []);

  useEffect(() => {
    if (access && access.token) getAccounts();
  }, [access])

  const loadSetChecked = (accounts) => {
    const checklist = accounts.map((account) => {
      const privileges = account.entity?.privileges || [];

      return {
        sumsub: privileges.some(
          (p) => p.name === 'sumsub_identification'
        ),
        regtank: privileges.some(
          (p) => p.name === 'regtank_identification'
        ),
      };
    });

    setChecked(checklist);
  };


  const getAccounts = (callback) => {
    runLoadAccounts(async () => {
      const { models } = await API.Admin.list_accounts({ nolimit: true });
      console.log(models);
      if (mounted) {
        setAccounts(models);
        loadSetChecked(models);
        if (typeof callback === 'function') callback();
      }
    });
  };

  const handleChecked = (accountId, type) => {
    runUpdateAccount(async () => {
      if (type === 'sumsub') {
        await API.Admin.update_account_sumsub_identity_verification_privilege(accountId);
      } else if (type === 'regtank') {
        await API.Admin.update_account_regtank_identity_verification_privilege(accountId);
      }

      getAccounts(() =>
        enqueueSnackbar('Identity Verification Privilege Updated', {
          variant: 'success',
        })
      );
    });
  };

  return (
    <Box className={classes.root}>
      <Card className={classes.card}>
        <CardHeader title="Identity Verification Privilege" />
        <CardContent>
          <Alert severity="info">
            Enable identity verification access for selected accounts.
          </Alert>
        </CardContent>
        <CardActions>
          <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography variant="h6">Accounts</Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h6">Sumsub</Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h6">Regtank</Typography>
              </TableCell>
            </TableRow>
              {accounts.map((account, index) => (
                <TableRow key={account.id}>
                  <TableCell>{account.name}</TableCell>

                  <TableCell align="center">
                    <Checkbox
                      checked={checked[index]?.sumsub || false}
                      onChange={() => handleChecked(account.id, 'sumsub')}
                    />
                  </TableCell>

                  <TableCell align="center">
                    <Checkbox
                      checked={checked[index]?.regtank || false}
                      onChange={() => handleChecked(account.id, 'regtank')}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardActions>
      </Card>
    </Box>
  );
};

export default IdentityVerification;